import * as React from 'react';
import { updatePurchaseType } from '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { PurchaseTypeSelectionBoxes } from './PurchaseTypeSelectionBoxes.js';

const PurchaseTypeSelectionBoxesContainer = ({ className , onSelection  })=>{
    const { activeVariant: { purchaseTypePrices , isAvailableForSubscription , isAvailableForInStoreSubscription ,  } , dispatch , selectedPurchaseType ,  } = useProductData();
    const handleSelection = React.useCallback((purchaseType)=>{
        dispatch(updatePurchaseType({
            purchaseType
        }));
        onSelection === null || onSelection === void 0 ? void 0 : onSelection(purchaseType);
    }, [
        dispatch,
        onSelection
    ]);
    return /*#__PURE__*/ React.createElement(PurchaseTypeSelectionBoxes, {
        className: className,
        isAvailableForInStoreSubscription: isAvailableForInStoreSubscription,
        onSelection: handleSelection,
        purchaseTypePrices: purchaseTypePrices,
        selectedPurchaseType: selectedPurchaseType,
        subscriptionTypeAllowed: isAvailableForSubscription
    });
};

export { PurchaseTypeSelectionBoxesContainer };
//# sourceMappingURL=PurchaseTypeSelectionBoxesContainer.js.map
